export default "__VITE_ASSET__DxKwj8he__"